const PrintDriverRefs = Object.freeze({
    DUMMY: 'dummy',
    PRINT: 'print',
    PRINTER_APP: 'printer_app',
});

module.exports = PrintDriverRefs;
